import React, { useState, useEffect } from "react";
import * as EvaluationService from "../../../../services/EvaluationServices";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { show, hide } from "redux-modal";
import { getAuthUserSelector } from "../../../../store/selectors/authSelector";
import {
  OrgChartContainer,
  OrgChartHeader,
  TreeContainer,
  ButtonClose,
} from "./evaluationOrgChart.styled";
import OrgNode from "./OrgNode";
import Detail from "./evaluationDetail.view";

const OrgChartContainer_Component = ({ filters, onlyOrgChart }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [orgChartData, setOrgChartData] = useState(null);
  const currentUser = useSelector(getAuthUserSelector);

  /**
   * Construye el árbol jerárquico desde el usuario especificado
   */
  const buildOrgChart = (employees, userEmail) => {
    if (!employees || employees.length === 0 || !userEmail) {
      return null;
    }

    // Buscar el usuario objetivo por su email en la lista de evaluadores
    let targetUserUuid = null;
    let targetUserData = null;

    for (const emp of employees) {
      if (emp.evaluator && emp.evaluator?.email === userEmail) {
        targetUserUuid = emp.evaluator.uuid;
        // Usar los datos del evaluador
        targetUserData = {
          name: emp.evaluator.name,
          surname: emp.evaluator.surname,
          email: emp.evaluator.email,
          userUuid: emp.evaluator.userUuid,
          uuid: emp.evaluator.uuid,
        };
        break;
      }
    }

    if (!targetUserUuid) {
      // Si no se encuentra como evaluador, retornar null
      return null;
    }

    // Crear mapa de empleados por UUID del evaluador
    const employeesByEvaluatorUuid = {};

    employees.forEach((emp) => {
      if (emp.evaluator && emp.evaluator.uuid) {
        if (!employeesByEvaluatorUuid[emp.evaluator.uuid]) {
          employeesByEvaluatorUuid[emp.evaluator.uuid] = [];
        }
        employeesByEvaluatorUuid[emp.evaluator.uuid].push(emp);
      }
    });

    // Función recursiva para construir el árbol
    const buildNode = (person, personUuid) => {
      const node = { ...person };

      // Buscar hijos usando el UUID
      const children = employeesByEvaluatorUuid[personUuid] || [];

      if (children.length > 0) {
        node.children = children.map((child) => {
          // Para cada hijo, usar su propio UUID (del evaluado que se convierte en evaluador)
          const childUuid = child.uuid || child.userUuid;
          return buildNode(child, childUuid);
        });
      }

      return node;
    };

    // Construir el árbol desde el usuario objetivo usando su UUID encontrado
    return buildNode(targetUserData, targetUserUuid);
  };

  const handlerClosePopup = (popupName) => {
    dispatch(hide(popupName));
  };

  const showEvaluation = async (data) => {
    dispatch(
      show("ModalForm", {
        body: (
          <>
            <div className="row mb-3">
              <div className="col-12 text-end">
                <ButtonClose
                  type="button"
                  onClick={() => handlerClosePopup("ModalForm")}
                >
                  <i className="fa-solid fa-xmark"></i>
                </ButtonClose>
              </div>
            </div>
            <div className="row">
              <div className="col-12">
                <Detail
                  data={data}
                  cancelAction={() => handlerClosePopup("ModalForm")}
                ></Detail>
              </div>
            </div>
          </>
        ),
      })
    );
  };

  const loadData = (filters) => {
    // Determinar el email a usar: si es onlyOrgChart usar el del filtro, sino el del usuario logado
    const targetEmail = onlyOrgChart
      ? "joseluisdeprado@deprado.eu"
      : currentUser?.email;

    const filtersF =
      filters && Object.keys(filters).length > 0
        ? { filters }
        : {
            filters: {
              year: new Date().getFullYear(),
              email: onlyOrgChart
                ? "joseluisdeprado@deprado.eu"
                : currentUser?.email,
            },
          };

    EvaluationService.consultEvaluations(filtersF).then((result) => {
      if (result && targetEmail) {
        const chart = buildOrgChart(result, targetEmail);
        setOrgChartData(chart);
      }
    });
  };

  useEffect(() => {
    // Si es onlyOrgChart, cargar siempre
    // Si no es onlyOrgChart, esperar a que currentUser esté disponible
    if (onlyOrgChart || currentUser) {
      loadData(filters);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filters, currentUser, onlyOrgChart]);

  if (!orgChartData) {
    return (
      <OrgChartContainer>
        <div className="text-center p-5">
          <i className="fa-solid fa-spinner fa-spin fa-2x text-secondary"></i>
          <p className="mt-3">{t("forms.consult.orgChart.loading")}</p>
        </div>
      </OrgChartContainer>
    );
  }

  return (
    <OrgChartContainer>
      {/* <OrgChartHeader>
        <h2>{t("forms.consult.orgChart.title")}</h2>
        <p>{t("forms.consult.orgChart.subtitle")}</p>
      </OrgChartHeader> */}
      <TreeContainer>
        <OrgNode
          node={orgChartData}
          onShowDetail={showEvaluation}
          isRoot={true}
          onlyOrgChart={onlyOrgChart}
        />
      </TreeContainer>
    </OrgChartContainer>
  );
};

export default OrgChartContainer_Component;
